import { Inter } from "next/font/google";

const fontSecondary = Inter({
  subsets: ["latin"],
  variable: "--theme-secondary-font",
  weight: ["300", "400", "500", "700"],
});
const secondaryFont = fontSecondary.className;

export default secondaryFont;
